import i18n from '@i18next/i18n';
import { STDLblPos, STBuiltInUnit, STTrendlineType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { ChartUILabelPosition } from '../interface/chart-ui.interface';

export const labelPositionTypeMap: Record<STDLblPos, ChartUILabelPosition> = {
    [STDLblPos.ctr]: ChartUILabelPosition.Center,
    [STDLblPos.r]: ChartUILabelPosition.Right,
    [STDLblPos.l]: ChartUILabelPosition.Left,
    [STDLblPos.t]: ChartUILabelPosition.Top,
    [STDLblPos.b]: ChartUILabelPosition.Bottom,
    // 轴内侧，靠下
    [STDLblPos.inBase]: ChartUILabelPosition.InBase,
    // 数据标签外，超出了图形在顶部
    [STDLblPos.outEnd]: ChartUILabelPosition.OutEnd,
    // 数据标签内，比较靠上，需要做offset移到内部
    [STDLblPos.inEnd]: ChartUILabelPosition.InEnd,
    [STDLblPos.bestFit]: ChartUILabelPosition.Center,
    // 默认位置居中，理论上不会有这个值
    [STDLblPos.PBDEFAULT]: ChartUILabelPosition.Center,
};

export const axisUnitLabelMap = {
    [STBuiltInUnit.hundreds]: { text: i18n.t('百'), value: 0.01 },
    [STBuiltInUnit.thousands]: { text: i18n.t('千'), value: 0.001 },
    [STBuiltInUnit.tenThousands]: { text: i18n.t('*10000'), value: 0.0001 },
    [STBuiltInUnit.hundredThousands]: { text: i18n.t('*100000'), value: 0.00001 },
    [STBuiltInUnit.millions]: { text: i18n.t('百万'), value: 0.000001 },
    [STBuiltInUnit.tenMillions]: { text: i18n.t('*10000000'), value: 0.0000001 },
    [STBuiltInUnit.hundredMillions]: { text: i18n.t('*100000000'), value: 0.00000001 },
    [STBuiltInUnit.billions]: { text: i18n.t('十亿'), value: 0.000000001 },
    [STBuiltInUnit.trillions]: { text: i18n.t('兆'), value: 0.0000000001 },

};

export type RegressionType = 'linear' | 'exponential' | 'logarithmic' | 'power' | 'polynomial';

export const trendLineTypeMap: Partial<Record<STTrendlineType, RegressionType>> = {
    [STTrendlineType.linear]: 'linear',  // 线性
    [STTrendlineType.exp]: 'exponential',    // 指数
    [STTrendlineType.log]: 'logarithmic',    // 对数
    [STTrendlineType.power]: 'power',    // 乘幂
    [STTrendlineType.poly]: 'polynomial',    // 多项式
    // MOVING_AVG = 'movingAvg' //  g2暂不支持 移动平均
};

export const trendLineNameMap: Record<STTrendlineType, string> = {
    [STTrendlineType.PBDEFAULT]: i18n.t('线性'),
    [STTrendlineType.linear]: i18n.t('线性'),
    [STTrendlineType.exp]: i18n.t('指数'),
    [STTrendlineType.log]: i18n.t('对数'),
    [STTrendlineType.power]: i18n.t('乘幂'),
    [STTrendlineType.poly]: i18n.t('多项式'),
    [STTrendlineType.movingAvg]: i18n.t('移动平均'),
};

